<template>
  <v-container grid-list-xl vendorScreen>
    <v-tabs slider-color="grey">
      <v-tab class="tab" :key="1" ripple>Details</v-tab>
      <v-tab class="tab" :key="2" ripple>Vendor Ranges</v-tab>
      <v-tab class="tab" :key="3" ripple>Vendor Product Codes</v-tab>
      <v-tab class="tab" :key="4" ripple>Vendor Department / Store</v-tab>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
        <v-container grid-list-xl>
          <v-form v-model="isAddValid">
            <v-layout row wrap>
              <v-flex lg4>
                <label class="blackLabel">* Vendor Name:</label>
                <v-text-field label="Name" v-model="objVendorEdit.name" required :rules="nameRules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">* Vendor Email:</label>
                <v-text-field label="Email" v-model="objVendorEdit.email" required :rules="emailRules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg4>
                <label class="blackLabel">* Vendor ( Hybris / ERP ):</label>
                <v-text-field label="Vendor ID" v-model="objVendorEdit.description" required :rules="descriptionRules" single-line solo></v-text-field>
              </v-flex>
              <v-flex lg12>
                <label class="blackLabel">* Vendor Address:</label>
                <v-text-field multi-line v-model="objVendorEdit.address" solo label="Address"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex lg6>
              <label class="blackLabel">Vendor Manufacturer:</label>
              <v-select @input="fncGetRanges" :items="vendorManufacturers" label="Manufacturer" class="dropdown" v-model="vendorManufacturer" autocomplete item-text="name" solo single-line></v-select>
            </v-flex>
            <v-flex class="whiteShort" lg6 v-if="vendorManufacturerRanges != ''">
              <label class="blackLabel">Vendor Ranges:</label>
              <v-select :items="vendorManufacturerRanges" @input="fncListRanges()" label="Manufacturer Range" class="dropdown" v-model="objVendorEdit.savedRanges" multiple autocomplete item-text="name" solo single-line></v-select>
            </v-flex>
            <table width="100%" style="margin-left: 1%;">
              <tr v-for="(r, index) in objVendorEdit.savedRanges" :key="index">
                <td valign="top">
                  <div><small>{{ objVendorEdit.savedRanges[index].headName }} - {{ objVendorEdit.savedRanges[index].name }}</small><a @click.prevent="fncRemoveRange(objVendorEdit.savedRanges[index].id32)"><i style="font-size:16px;" class="material-icons">remove_circle_outline</i></a><br /></div>
                </td>
              </tr>
              <!--<tr v-for="(group,group_name,index) in objVendorEdit.savedRanges" :key="index">
                <td valign="top">
                  <div v-for="(x,y,z) in group"><small>{{ group_name }} - {{ x.name }}</small><a @click.prevent="fncRemoveRange(x.id32)"><i style="font-size:16px;" class="material-icons">remove_circle_outline</i></a><br /></div>
                </td>
              </tr>-->
            </table>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex lg12>
              <input type="file" id="articleImport" @change="fncSetImageObj">
            </v-flex>
            <v-flex lg3 v-for="(product_code, index) in objVendorEdit.product_codes">
              <v-text-field label="Product Code" v-model="objVendorEdit.product_codes[index].value" single-line solo></v-text-field>
              <a @click="fncRemoveVendorRange(index)" class="departmentRangeRemove">Remove</a>
            </v-flex>
            <v-flex lg3>
              <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Save Product Code</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex xs3 v-if="objAuthorize.department_active == 1" style="padding-left: 0px !important; margin-left: 0px !important;">
              <v-text-field append-icon="search" label="Filter Branches" style="margin-left: 0px !important;" solo single-line v-model="search"></v-text-field>
            </v-flex>
            <v-data-table select-all :headers="branchHeaders" :search="search" ref="sortableTable" :items="branchesDepartments" hide-actions class="elevation-1 settingTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
              <template slot="headers" slot-scope="row">
                <tr>
                  <th class="vendor-store-header" v-for="header in branchHeaders" :key="header.value" :width="header.width" >
                    <span v-if="header.value === 'select_all'"><v-switch class="selectall-switch"  @change="selectAllItems" label="Select All" :indeterminate="isIndeterminate" v-model="selectAll"> Select All</v-switch></span>
                    <span v-else> {{ header.text }} </span>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr >
<!--                  <td width="15%"  class="text-middle"></td>-->
                  <td colspan="2" width="20%"  style="vertical-align: middle !important;"><v-switch @change="fncChangeObject()" v-model="props.item.active"></v-switch></td>
                  <td width="40%">{{ props.item.name }}</td>
                  <td width="40%"><v-select style="width:90%;border: none !important;" :items="departmentList" label="Select Departments" v-model="props.item.departments" item-text="name" item-value="id" autocomplete multiple solo></v-select></td>
                </tr>
              </template>
            </v-data-table>

<!--            <v-data-table-->
<!--              :headers="branchHeaders"-->
<!--              :search="search"-->
<!--              ref="sortableTable"-->
<!--              :items="branchesDepartments"-->
<!--              hide-actions-->
<!--              class="elevation-1 settingTable"-->
<!--              disable-initial-sort-->
<!--              :rows-per-page-items="[20, 40, 60, 80, 100]"-->
<!--            >-->
<!--              <template slot="items" slot-scope="props">-->
<!--                <tr class="sortableRow" id="rows">-->
<!--                  <td width="20%">-->
<!--                    <v-checkbox @change="fncChangeObject()" v-model="props.item.active"></v-checkbox>-->
<!--                  </td>-->
<!--                  <td width="40%">{{ props.item.name }}</td>-->
<!--                  <td width="40%">-->
<!--                    <v-select-->
<!--                      style="width: 90%; border: none !important;"-->
<!--                      :items="departmentList"-->
<!--                      label="Select Departments"-->
<!--                      v-model="props.item.departments"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      autocomplete-->
<!--                      multiple-->
<!--                      solo-->
<!--                    ></v-select>-->
<!--                  </td>-->
<!--                </tr>-->
<!--              </template>-->

<!--              &lt;!&ndash; Include a checkbox in the table header for "Select All" &ndash;&gt;-->
<!--              <template slot="header" slot-scope="{ props: { headers } }">-->
<!--                <tr>-->
<!--                  <th width="20%">-->
<!--                    <v-checkbox @change="selectAllItems" :indeterminate="isIndeterminate" v-model="selectAll"></v-checkbox>-->
<!--                  </th>-->
<!--                  <th v-for="header in headers" :key="header.value" :width="header.width">-->
<!--                    {{ header.text }}-->
<!--                  </th>-->
<!--                </tr>-->
<!--              </template>-->
<!--            </v-data-table>-->


          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <div class="pl-4 pr-1 pb-4 buttonHolder">
      <div style="float: right">
        <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
        <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
        <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="update_vars" @click.stop="fncEditVendor()">Update</v-btn>
        <small>* The button will activate once all required fields have been completed</small>
      </div>
    </div>
    <!--<v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-flex lg6>
          <label class="blackLabel">* Vendor Name:</label>
          <v-text-field label="Name" v-model="objVendorEdit.name" required :rules="nameRules" single-line solo></v-text-field>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">* Vendor Email:</label>
          <v-text-field label="Email" v-model="objVendorEdit.email" required :rules="emailRules" single-line solo></v-text-field>
        </v-flex>
        <v-flex lg12>
          <label class="blackLabel">* Vendor Description:</label>
          <v-text-field label="Description" v-model="objVendorEdit.description" required :rules="descriptionRules" single-line solo></v-text-field>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">* Vendor Manufacturer:</label>
          <v-select @input="fncGetRanges" :items="vendorManufacturers" label="Manufacturer" class="dropdown" v-model="vendorManufacturer" :rules="manufacturerRules" autocomplete item-text="name" solo single-line></v-select>
        </v-flex>
        <v-flex class="whiteShort" lg6 v-if="vendorManufacturerRanges != ''">
          <label class="blackLabel">* Vendor Ranges:</label>
          <v-select :items="vendorManufacturerRanges" @input="fncListRanges()" label="Manufacturer Range" class="dropdown" v-model="objVendorEdit.savedRanges" multiple autocomplete :rules="rangeRules" item-text="name" solo single-line></v-select>
        </v-flex>
        <table width="100%" style="margin-left: 1%;">
          <tr v-for="(group,group_name,index) in objVendorEdit.objList" :key="index">
            <td valign="top">
              <div v-for="(x,y,z) in group"><small>{{ group_name }} - {{ x.name }}</small><a @click.prevent="fncRemoveRange(x.id32)"><i style="font-size:16px;" class="material-icons">remove_circle_outline</i></a><br /></div>
            </td>
          </tr>
        </table>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncEditVendor()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>-->
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data() {
      return {
        selectAll: false,
        isIndeterminate: false,
        vendorDepartmentBranches: '',
        search: '',
        isAddValid: false,
        articleImport: '',
        vendorName: '',
        vendorDescription: '',
        vendorManufacturer: [],
        nameRules: [
          v => !!v || 'Vendor name is required',
        ],
        descriptionRules: [
          v => !!v || 'Vendor description is required',
        ],
        manufacturerRules: [
          v => !!v || 'Vendor manufacturer is required',
        ],
        rangeRules: [
          v => !!v || 'Manufacturer range is required',
        ],
        emailRules: [
          v => !!v || 'Vendor email is required',
        ],
        manufacturers: [
          {id: '1', text: 'Manufacturer One'},
          {id: '2', text: 'Manufacturer Two'}
        ],
        pdfOptions: [
          /*{ key: 'one', label: 'One', status: false, altLabel: '' },
          { key: 'two', label: 'Two', status: false, altLabel: '' },
          { key: 'three', label: 'Three', status: false, altLabel: '' },*/
        ],
        pdfHeaders: [
          {text: 'Display', value: 'status', width: '10%'},
          {text: 'Description', value: 'label', width: '45%'},
          {text: 'Alternate Description', value: 'altLabel', width: '45%'}
        ],
        branchesDepartments: [],
        branchHeaders: [
          {text: 'Select all', value: 'select_all', width: '15%'},
          {text: '', value: '', width: '15%'},
          {text: 'Branch', value: 'name', width: '40%'},
          {text: 'Department', value: '', width: '40%'}
        ],
      };
    },
    methods: {
      selectAllItems() {
        const selectedValue = this.selectAll;
        if (this.selectAll) {
          const firstItemDepartments = this.branchesDepartments[0].departments;
          this.branchesDepartments.forEach((item) => {
            item.departments = firstItemDepartments;
            item.active = selectedValue;
          });
        } else {
          // Clear all departments when "Select All" is unchecked
          this.branchesDepartments.forEach((item) => {
            item.departments = [];
            item.active = selectedValue;
          });
        }

      },
      fncRemoveVendorRange(index) {
        var newProductCodes = [];
        for (var i in this.objVendorEdit.product_codes) {
          if (i != index) {
            newProductCodes.push(this.objVendorEdit.product_codes[i]);
          }
        }
        if (newProductCodes.length == 0) {
          newProductCodes = [{value: ''}];
        }
        this.objVendorEdit.product_codes = newProductCodes;
      },
      fncSetImageObj(e) {
        var files = e.target.files || e.dataTransfer.files;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          var articleNumbers = reader.result;
          var articleRows = articleNumbers.split("\r\n");
          if (articleRows.length > 0) {
            // vm.objVendorEdit.product_codes = [];
            for (var a in articleRows) {
              if (articleRows[a] != '') {
                vm.objVendorEdit.product_codes.push({value: articleRows[a]});
              }
            }
          }
          /*vm.objRows = articleNumbers.split("\r\n");
          vm.fileName = files[0].name;*/
        }
        reader.readAsText(files[0]);
      },
      fncChangeObject() {
        var toPush = [];

        for (var b in this.branchesDepartments) {
          if (this.branchesDepartments[b].active == true) {
            toPush.push(this.branchesDepartments[b]);
          }
        }
        for (var b in this.branchesDepartments) {
          if (this.branchesDepartments[b].active == false) {
            toPush.push(this.branchesDepartments[b]);
          }
        }

        this.branchesDepartments = toPush;

      },
      fncAddProductCode() {
        this.objVendorEdit.product_codes.push({value: ''});
      },
      fncRemoveRange(id) {

        this.$store.commit('fncChangeObjList', id);

        /*var toReturn = [];

        for (var x in this.vendorManufacturerRange) {
          if (this.vendorManufacturerRange[x].id32 != id) {
            toReturn.push(this.vendorManufacturerRange[x]);
          }
        }

        this.vendorManufacturerRange = toReturn;
        this.fncListRanges();*/

      },
      fncListRanges() {
        this.$store.commit('fncResetObjList');
      },
      fncGetRanges() {
        // this.$store.commit('fncEmptyVendorRange');
        this.$store.dispatch('fncGetManufacturerRanges', this.vendorManufacturer);
      },
      fncHideModal() {
        this.$store.commit('hideModal');
        setTimeout(function () {
          location.reload();
        }, 1000)
      },
      fncEditVendor() {
        this.$store.dispatch('fncEditvendor', this.branchesDepartments);
      }
    },

    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd',
        'objVendorEdit',
        'vendorManufacturers',
        'vendorManufacturerRanges',
        'departmentList',
        'branchList'
        //'vendorDepartmentBranches'
      ]),
      update_vars(){
        if (this.isAddValid && this.objVendorEdit.product_codes.every(item => item.value !== '') )
          return  false
        else
          return  true
      }
    },
    watch: {
      objVendorEdit() {
      }
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateBranches');
      // this.$store.dispatch('fncVendorDepartmentBranches', this.objVendorEdit.id );
    },
    mounted() {

      this.vendorDepartmentBranches = this.globalModalParams.branchDepartments;

      if( this.branchList.length > 0 ) {
        var toPush = [];
        for( var b in this.branchList ) {
          if( this.branchList[b].id != '' ) {
            if( this.vendorDepartmentBranches[this.branchList[b].id] != null ) {
              var isResponsible = this.vendorDepartmentBranches[this.branchList[b].id].is_responsible == 1 ? true : false;
              var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: true, responsible_rep: isResponsible, departments: this.vendorDepartmentBranches[this.branchList[b].id].departments };
              toPush.push( miniPush );
            } else {
              var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [] };
              toPush.push( miniPush );
            }
          }
        }

        this.branchesDepartments = toPush;
        var toPush = [];

        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == true ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }
        for( var b in this.branchesDepartments ) {
          if( this.branchesDepartments[b].active == false ) {
            toPush.push( this.branchesDepartments[b] );
          }
        }

        this.branchesDepartments = toPush;
      }
    },
    watch: {
      branchList() {
        if( this.branchList.length > 0 ) {
          var toPush = [];
          for( var b in this.branchList ) {
            if( this.branchList[b].id != '' ) {
              if( this.vendorDepartmentBranches[this.branchList[b].id] != null ) {
                var isResponsible = this.vendorDepartmentBranches[this.branchList[b].id].is_responsible == 1 ? true : false;
                var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: true, responsible_rep: isResponsible, departments: this.vendorDepartmentBranches[this.branchList[b].id].departments };
                toPush.push( miniPush );
              } else {
                var miniPush = { id: this.branchList[b].id, name: this.branchList[b].name, active: false, responsible_rep: false, departments: [] };
                toPush.push( miniPush );
              }
            }
          }

          this.branchesDepartments = toPush;
          var toPush = [];

          for( var b in this.branchesDepartments ) {
            if( this.branchesDepartments[b].active == true ) {
              toPush.push( this.branchesDepartments[b] );
            }
          }
          for( var b in this.branchesDepartments ) {
            if( this.branchesDepartments[b].active == false ) {
              toPush.push( this.branchesDepartments[b] );
            }
          }

          this.branchesDepartments = toPush;

        }
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
